module.exports = __webpack_public_path__ + "img/warning_payment.6da5b342.png";